module.exports = __webpack_public_path__ + "img/icon-file.632593a4.svg";